import React, { useState } from "react";

const SearchComponent = ({
  accountType,
  handleChange,
  handleLeadTypeChange,
  leadType,
  setFilterByObj,
  filterByObj,
}) => {

  const [error, setError] = useState("");

  const commonStyle = {
    // border: "1px solid",
    borderRadius: "5px",
    height: "40px",
    lineHeight: "1.5",
  };

  // const getCount = (value) => {
  //   if (!value) return 0;
  //   return value.split(",").filter(Boolean).length;
  // };



  return (
    <>
      {/* Search */}
      <div className="col-12 col-md-3">
        <label className="form-label mb-1">Search Here</label>

        <input
          type="search"
          className="form-control shadow-none"
          placeholder="Search by id,companyid,mob no,email"
          value={filterByObj.search || ""}
          style={{ border: "1px solid #8E3E63", width: "300px" }}


          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();

              setFilterByObj((prev) => ({
                ...prev,
                search: (prev.search || "") + ",",
              }));
            }
          }}


          onChange={(e) => {
            let value = e.target.value;

            // remove new lines / tabs (NOT space here)
            value = value.replace(/[\n\t]+/g, ",");

            // remove multiple commas
            value = value.replace(/,+/g, ",");

            // remove leading/trailing comma
            value = value.replace(/^,|,$/g, "");

            setFilterByObj((prev) => ({
              ...prev,
              search: value,
            }));
          }}


          onPaste={(e) => {
            e.preventDefault();

            let value = e.clipboardData.getData("text");

            // convert spaces/new lines/tabs → comma
            value = value.replace(/[\s\n\t]+/g, ",");

            // remove multiple commas
            value = value.replace(/,+/g, ",");

            // remove leading/trailing comma
            value = value.replace(/^,|,$/g, "");

            setFilterByObj((prev) => ({
              ...prev,
              search: value,
            }));
          }}
        />
        {/* {error && (<small style={{ color: "red" }}>{error}</small>)} */}
      </div>

      {/* Account Type */}
      <div className="col-6 col-md-2">
        <label >Acc. Type</label>
        <select
          value={accountType}
          onChange={handleChange}
          className="form-select shadow-none"
          style={commonStyle}
        >
          <option value="">Select</option>
          <option value="B2B">B2B</option>
          <option value="B2C">B2C</option>
        </select>
      </div>

      {/* Lead Type */}
      <div className="col-6 col-md-2">
        <label>Lead Type</label>
        <select
          value={leadType}
          onChange={handleLeadTypeChange}
          className="form-select shadow-none"
          style={commonStyle}
        >
          <option value="">Select</option>
          <option value="Hot">Hot</option>
          <option value="Warm">Warm</option>
          <option value="Cold">Cold</option>
        </select>
      </div>
    </>
  );
};

export default SearchComponent;